import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, createForOfIteratorHelper as _createForOfIteratorHelper, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useCallback } from 'react';
import { Element, Editor, Node } from 'slate';
import { useSlate } from 'slate-react';
import Prism from 'prismjs';
import { normalizeTokens } from './normalize-tokens.js';
import isHotkey from 'is-hotkey';
import { HOTKEYS, toggleMark } from './index.js';
import { Types } from './contants.js';

var useDecorate = function useDecorate(editor) {
  return useCallback(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        node = _ref2[0];

    _ref2[1];

    if (Element.isElement(node) && node.type === Types.codeLine) {
      var _editor$nodeToDecorat;

      return ((_editor$nodeToDecorat = editor.nodeToDecorations) === null || _editor$nodeToDecorat === void 0 ? void 0 : _editor$nodeToDecorat.get(node)) || [];
    }

    return [];
  }, [editor.nodeToDecorations]);
};

var getChildNodeToDecorations = function getChildNodeToDecorations(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      block = _ref4[0],
      blockPath = _ref4[1];

  var nodeToDecorations = new Map();
  var text = block.children.map(function (line) {
    return Node.string(line);
  }).join('\n');
  var language = 'html'; // block.language;

  var tokens = Prism.tokenize(text, Prism.languages[language]);
  var normalizedTokens = normalizeTokens(tokens); // make tokens flat and grouped by line

  var blockChildren = block.children;

  for (var index = 0; index < normalizedTokens.length; index++) {
    var _tokens = normalizedTokens[index];
    var element = blockChildren[index];

    if (!nodeToDecorations.has(element)) {
      nodeToDecorations.set(element, []);
    }

    var start = 0;

    var _iterator = _createForOfIteratorHelper(_tokens),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var token = _step.value;
        var length = token.content.length;

        if (!length) {
          continue;
        }

        var end = start + length;
        var path = [].concat(_toConsumableArray(blockPath), [index, 0]);

        var range = _objectSpread2({
          anchor: {
            path: path,
            offset: start
          },
          focus: {
            path: path,
            offset: end
          },
          token: true
        }, Object.fromEntries(token.types.map(function (type) {
          return [type, true];
        })));

        nodeToDecorations.get(element).push(range);
        start = end;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return nodeToDecorations;
}; // precalculate editor.nodeToDecorations map to use it inside decorate function


var SetNodeToDecorations = function SetNodeToDecorations() {
  var editor = useSlate();
  var blockEntries = Array.from(Editor.nodes(editor, {
    at: [],
    mode: 'highest',
    match: function match(n) {
      return Element.isElement(n) && n.type === Types.codeBlock;
    }
  }));
  var nodeToDecorations = mergeMaps.apply(void 0, _toConsumableArray(blockEntries.map(getChildNodeToDecorations)));
  editor.nodeToDecorations = nodeToDecorations;
  return null;
};

var mergeMaps = function mergeMaps() {
  var map = new Map();

  for (var _len = arguments.length, maps = new Array(_len), _key = 0; _key < _len; _key++) {
    maps[_key] = arguments[_key];
  }

  for (var _i = 0, _maps = maps; _i < _maps.length; _i++) {
    var m = _maps[_i];

    var _iterator2 = _createForOfIteratorHelper(m),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        map.set.apply(map, _toConsumableArray(item));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return map;
};

var useOnKeydown = function useOnKeydown(editor) {
  var onKeyDown = useCallback(function (e) {
    if (isHotkey('tab', e)) {
      // handle tab key, insert spaces
      e.preventDefault();
      Editor.insertText(editor, '  ');
    }

    for (var hotkey in HOTKEYS) {
      if (isHotkey(hotkey, e)) {
        e.preventDefault();
        var mark = HOTKEYS[hotkey];
        toggleMark(editor, mark);
      }
    }
  }, [editor]);
  return onKeyDown;
};

export { SetNodeToDecorations, useDecorate, useOnKeydown };